import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { CrBsModalServiceUpgraded } from './bsmodal.service';
import { BsModalService } from "ngx-bootstrap";

export const Ng1BsModalService = angular
    .module('control-room.shared.services.CrBsModalServiceUpgraded', [])
    .factory('bsModalService',downgradeInjectable(BsModalService));